import { useEffect, useState } from "react"
import {  Link, useParams } from 'react-router-dom'
import { APPLICATION_API_END_POINT as api } from '../../../../../utils/constant'
import {  CgArrowLeft, CgClose } from 'react-icons/cg'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'; 
import ImageWithFallback from '../../../../components/ImageWithFallback'
import CircleDownloadButton from "../../../../../components/Buttons/CircleDownloadButton"
import { TfiEmail } from 'react-icons/tfi'
import axios from "axios"
import { useSelector } from "react-redux"
import user1 from "../../../../assets/users/lana-byrd.png"
import TruncateText from "../../../../../components/TruncateText"


const ApplicationDetail =()=>{
const {application_id} = useParams()
const {user} = useSelector(store=>store.user);
const [applicationSelected, setApplicationSelected] = useState({})
const [candidateSelected, setCandidateSelected] = useState({})
const [showModal, setShowModal] = useState(false)
const [showSendEmailModal, setShowSendEmailModal] = useState(false)
// const {showScroll, setshowScroll} = useOutletContext()
const [loading, setLoading] = useState(false)

useEffect(()=>{
    axios.post(api+"/"+application_id, {
        "user_id": 2
    })
        .then(response => {
        console.log("application selected:", response.data)
        setApplicationSelected(response.data)
        setCandidateSelected(response.data?.user)
        })
        .catch(error => {
        console.error("Error fetching candidate selected data:", error);
        })
    }, [application_id]
)
return (
    <div className="layout-1">
   <Link to={`/mira-recruteur/offre`} className="flex gap-2 items-center mb-4 text-primary-text text-sm">
        <CgArrowLeft/>
        <h1 className=''>Retour à la liste</h1>
      </Link>
 <div className="card-1">
      <div className="card-1-content">
        <h2 className="card-1-title">{applicationSelected?.offer?.job_title}</h2>  
        <div className="flex flex-wrap gap-4 ">
            {applicationSelected?.offer?.required_skills?.map((item, index)=>{
             return <div key={index} className="font-[490] px-6 py-2 bg-gray-100 text-primary-text rounded-lg">
              {item?.name}
            </div>
            })}
            
          </div>
        <TruncateText maxChars={200} className="card-1-description">{applicationSelected?.offer?.description}</TruncateText>
       
      </div>
      <div className="card-1-image" style={{ backgroundImage: `url(https://i.ibb.co/Kr4b0zJ/152013403-10158311889099633-8423107287930246533-o.jpg)` }}></div>
    </div>


                  
        {/* <div className="bg-white overflow-hidden shadow rounded-lg border">
        <div className="px-4 py-5 sm:px-6">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
            Détail de l'offre
            </h3>
        
        </div>
    <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
        <dl className="sm:divide-y sm:divide-gray-200">
           
            <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                    Type de contrat
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {applicationSelected?.offer?.contract_type}
                </dd>
            </div>
            <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                    Méthode de travail
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {applicationSelected?.offer?.working_method}
                </dd>
            </div>
            <div className="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                    Salaire
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {applicationSelected?.offer?.salary}
                </dd>
            </div>
        </dl>
    </div>
</div> */}

      
            <div className="flex justify-between items-center mb-4 border rounded-md py-4 px-6 bg-gradient-to-r from-[#fadcff] to-[#e2dceb]">
                   <div className="flex gap-4 items-center">
          {loading ?
            <Skeleton circle={true} height={50} width={50} highlightColor='#fbfbfb' baseColor='#e9e9e9'/>
          :
            <ImageWithFallback src={candidateSelected?.image || user1} className=" size-20 bg-gray-100 rounded-md object-cover border border-white/50 " defaultType="user"/>
          }
   
       
          <div className='flex flex-col justify-between  items-start '>
          {loading ?
            <Skeleton width={100} highlightColor='#fbfbfb' baseColor='#e9e9e9'/>
          :
          <h1 className='text-lg font-semibold text-start'>{candidateSelected?.candidate_profile?.name }</h1>
          }

          {loading ?
            <Skeleton width={150} highlightColor='#fbfbfb' baseColor='#e9e9e9'/>
          :
          <p className='text-sm text-start'>{candidateSelected?.candidate_profile?.current_job }</p>
          } 
            
          </div>
        </div>
                <div className="flex items-center gap-x-2">
                <CircleDownloadButton/>
                   
                    <button 
                    onClick={()=>setShowSendEmailModal(true)}
                    className="p-2 size-12 flex justify-center items-center border-2 border-white rounded-full text-white font-bold"><TfiEmail/></button>
                </div>
            </div>
                    {
                        loading ?
                        <div className="flex flex-wrap gap-2 mb-4">
                            <Skeleton  height={25} width={200} className='rounded-xl' highlightColor='#fbfbfb' baseColor='#e9e9e9'/>
                            <Skeleton  height={25} width={200} className='rounded-xl' highlightColor='#fbfbfb' baseColor='#e9e9e9'/>                    
                        </div>
                        : 
                        <div className="flex flex-wrap gap-2 mb-4">
                            <div className="py-1 text-sm px-2 text-primary-text rounded-full bg-gray-50">{candidateSelected?.candidate_profile?.phone }</div>
                            <div className="py-1 text-sm px-2 text-primary-text rounded-full bg-gray-50">{candidateSelected?.candidate_profile?.address }</div>
                        </div>
                    }
{applicationSelected?.note &&

<div className="rounded">
                    <div className=" w-full h-56 flex flex-col justify-between items-start  bg-primary-beige  rounded-lg mb-6 py-5 px-4">
                        <div>
                            <h4 className="text-gray-800  font-bold mb-3 text-start">Note</h4>
                            <p className="text-gray-800  text-sm">Probabo, inquit, sic agam, ut labore et voluptatem sequi nesciunt, neque porro quisquam est, quid malum, sensu iudicari</p>
                        </div>
                        <div className="w-full flex flex-col items-start">
                            <div aria-label="time" role="contentinfo" className="mb-3 border border-gray-800 rounded-full px-3 py-1 text-gray-800  text-xs flex items-center">
                                <svg  xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-alarm" width="16" height="16" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z"></path>
                                    <circle cx="12" cy="13" r="7"></circle>
                                    <polyline points="12 10 12 13 14 13"></polyline>
                                    <line x1="7" y1="4" x2="4.25" y2="6"></line>
                                    <line x1="17" y1="4" x2="19.75" y2="6"></line>
                                </svg>
                                <p className="ml-2">7 Sept, 23:00</p>
                            </div>
                            <div className="flex items-center justify-between text-gray-800  w-full">
                                <p className="text-sm">March 28, 2020</p>
                                <button className="w-8 h-8 rounded-full bg-primary-green  text-white flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-offset-2  focus:ring-black" aria-label="edit note" role="button">
                                    <svg  xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-pencil text-emerald-600" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z"></path>
                                        <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"></path>
                                        <line x1="13.5" y1="6.5" x2="17.5" y2="10.5"></line>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    
                   
                </div>
}


            <div className="border rounded-md grid grid-cols-2 md:grid-cols-3 gap-4 text-start mt-4 py-4 px-6 mb-4">
        <div>
          <p className='text-sm text-primary-text'>Disponibilité</p>
          <p className='font-semibold text-sm'>{candidateSelected?.candidate_profile?.is_avalaible ? "Oui" : "Non"}</p>
        </div>
        <div>
          <p className='text-sm text-primary-text'>Diplôme</p>
          <p className='font-semibold text-sm'>{candidateSelected?.candidate_profile?.highest_diploma}</p>
        </div>
        <div>
          <p className='text-sm text-primary-text'>Année d'obtention</p>
          <p className='font-semibold text-sm'>{candidateSelected?.candidate_profile?.phone}</p>
        </div>
      </div>

            <div className="space-y-6">
                <div className="flex-col text-start">
                    {
                        loading ?
                        <Skeleton count={2} height={10} highlightColor='#fbfbfb' baseColor='#e9e9e9'/>
                        :
                        <p className="text-primary-text">
                            {candidateSelected?.candidate_profile?.bio ||
                            "Aucune bio disponible pour ce candidat"}
                        </p>
                    }
                   
                </div>
                { 
                    candidateSelected?.candidate_profile?.resume_skills && 
                    <div className="flex-col text-start">
                        <h4 className=' font-semibold  mb-2'>Compétences</h4>
                        <div className=" flex gap-2">
                        { 
                                candidateSelected?.candidate_profile?.resume_skills?.map((skill, index)=>{
                                    return (
                                        <div key={index} className="py-2 px-6 text-primary-text bg-gray-50">{skill?.name}</div>
                                    )
                                }
                                )
                            }
                            
                        </div>
                    </div>
                }

                {
                    loading ?
                    <>
                        <div className="flex-col items-start flex mb-4">
                        <Skeleton width={200} height={15} highlightColor='#fbfbfb' baseColor='#e9e9e9'/>
                        </div>
                        <Skeleton count={2} height={10} highlightColor='#fbfbfb' baseColor='#e9e9e9' className='w-full'/>
                    </>
                    :
                    <>
                        {/* Expérience */}
            { 
                candidateSelected?.candidate_profile?.experiences && 
                <div className="flex-col text-start">
                    <h4 className=' font-semibold  mb-4'>Expérience</h4>
                    {
                        candidateSelected?.candidate_profile?.experiences?.map((experience, index)=>{
                            return(
                                <div key={index}  className="flex gap-4 items-start w-full  mb-6 py-4 border-b">
                                    <div className="rounded-full bg-gray-50 border border-gray-300 flex items-center justify-center size-12 min-w-12">
                                        <svg fill="#6b7280" version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" 
                                        width="30px" height="30px" viewBox="0 0 64 64" enable-background="new 0 0 64 64"
                                        className='size-6 '  >
                                        <g>
                                        <path d="M62,16H42.727C42.064,13.082,39.791,8,32,8s-10.064,5.082-10.727,8H2c-1.104,0-2,0.896-2,2v36c0,1.104,0.896,2,2,2h60
                                            c1.104,0,2-0.896,2-2V18C64,16.896,63.104,16,62,16z M32,12c4.335,0,5.98,2.244,6.608,4H25.388C26.018,14.253,27.669,12,32,12z
                                            M60,20v8H4v-8H60z M29,32h6v2h-6V32z M4,52V32h21v4c0,1.104,0.896,2,2,2h10c1.104,0,2-0.896,2-2v-4h21v20H4z"/>
                                        </g>
                                        </svg>
                                    </div>
                                {/* <img src={bookmaker} alt="entreprise" className='w-12 h-12 rounded-full bg-gray-50 border' /> */}
                                <div className='w-full'>
                                    <div className="flex justify-between items-start mb-2">                            
                                        <div className="text-start flex-col">
                                            <h6 className='text-base font-semibold'>{experience?.title}</h6>
                                            <div className="inline-block gap-2 text-sm ">
                                            {experience?.company} . {experience?.address}
                                            </div>
                                        </div>
                                        <p className='text-sm'>{experience?.start_month} {experience?.start_year} - {experience?.start_month} {experience?.end_year}</p>
                                    </div>
                                    <p className=' text-primary-text'>{experience?.description}</p>
                                </div>
                                </div>   
                            )
                        })
                    }
                
                </div>
            }
                {
                    candidateSelected?.candidate_profile?.educations && 
                    <div className="flex-col text-start">
                        <h4 className='font-semibold mb-6 text-lg'>Education</h4>
                        {
                        candidateSelected?.candidate_profile?.educations?.map((education, index) => {
                            return (
                            <div key={index} className="flex gap-4 items-start w-full mb-6 py-4 border-b">
                                <div className="rounded-full bg-gray-50 border border-gray-300 flex items-center justify-center size-12 min-w-12">
                                <svg width="24px" height="24px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"
                                className='size-7 ' 
                                >
                                <path d="M7.5 4.5L11.5 6.5V14.5H3.5V6.5L7.5 4.5ZM7.5 4.5V0M0 14.5H15M1.5 14.5V8.5H3.5M13.5 14.5V8.5H11.5M6.5 14.5V11.5H8.5V14.5M7.5 0.5H10.5V2.5H7.5M7.5 9.5C6.94772 9.5 6.5 9.05228 6.5 8.5C6.5 7.94772 6.94772 7.5 7.5 7.5C8.05228 7.5 8.5 7.94772 8.5 8.5C8.5 9.05228 8.05228 9.5 7.5 9.5Z" stroke="#6b7280"/>
                                </svg>
                                </div>

                                <div className='w-full'>
                                <div className="flex justify-between items-start mb-3">                            
                                    <div className="text-start">
                                    <h6 className="text- font-semibold">{education?.school || 'Etablissement Inconnu'}</h6>
                                    <div className="text-sm text-gray-600">{education?.address || 'Etablissement Inconnu'}</div>
                                    </div>
                                    <p className='text-sm text-gray-500'>{education?.start_year} - {education?.end_year}</p>
                                </div>
                                <p className='text-primary-text text-sm'>
                                    {education?.description || 'No description available for this education.'}
                                </p>
                                </div>
                            </div>   
                            )
                        })
                        }
                    </div>
                    }
                { 
                  candidateSelected?.candidate_profile?.languages && 
                  <div className="flex-col text-start mb-6">
                      <h4 className=' font-semibold  mb-4'>Langues</h4>
                      <div className=" flex items-center gap-2 flex-wrap">
                      {
                          candidateSelected?.candidate_profile?.languages?.map((language, index)=>{
                              return(
                                  <div key={index}  className="py-2 pl-4 pr-3.5 text-primary-text flex gap-4 items-center border rounded-sm">
                                      <div className="w-8 h-8 bg-primary-black flex items-center justify-center text-white rounded-full uppercase">
                                      {language?.title?.slice(0, 2).toUpperCase()}
                                      </div>
                                      <div className="flex flex-col gap-y-1 text-primary-black">
                                          <p className='text-start font-semibold'>{language?.title}</p>
                                          <p>{language?.merit}</p>
                                      </div>
                                  </div>
                              )}
                          )
                      }
                      </div>
                  </div>
                }
                <br />
            </>
                }
                </div>
           
</div>

)
}

export default ApplicationDetail 